module.exports = __webpack_public_path__ + "static/paleosite_morphing4-608d1bf92de040d2a50659385a26c892.png";